module.exports = __webpack_public_path__ + "img/1671652690-huge.18d44b56.jpg";